module.exports = __webpack_public_path__ + "static/media/thumb.c7830963.jpg";